module.exports = __webpack_public_path__ + "assets/img/visible.dfccb4f1.svg";